import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { trackSdkSetupSdkConnected } from '../../analytics';
import { useOnboardingStorage, useSdkActivePolling } from '../../hooks';
import { SdkNextSteps } from '../SdkNextSteps/SdkNextSteps';
import { SdkSetupConnectionIndicator } from '../SdkSetupConnectionIndicator/SdkSetupConnectionIndicator';
import { SdkSetupContentHeader } from '../SdkSetupContentHeader/SdkSetupContentHeader';
import { SdkSetupSnippets } from '../SdkSetupSnippets/SdkSetupSnippets';

import styles from './SdkSetupContent.module.css';

export const SdkSetupContent: FC = () => {
  const hasTrackedConnection = useRef(false);
  const { sdk } = useOnboardingStorage();
  const { isActive } = useSdkActivePolling(sdk);

  useEffect(() => {
    if (isActive && !hasTrackedConnection.current) {
      trackSdkSetupSdkConnected(sdk);
      hasTrackedConnection.current = true;
    }
  }, [isActive, sdk]);

  return (
    <>
      <div className={styles.container}>
        <SdkSetupConnectionIndicator isActive={isActive} />
        <SdkSetupContentHeader sdk={sdk} />
        <SdkSetupSnippets />
      </div>
      <SdkNextSteps isActive={isActive} />
    </>
  );
};
